import { render, staticRenderFns } from "./ImageBlob.vue?vue&type=template&id=12aab808&scoped=true"
import script from "./ImageBlob.vue?vue&type=script&lang=js"
export * from "./ImageBlob.vue?vue&type=script&lang=js"
import style0 from "./ImageBlob.vue?vue&type=style&index=0&id=12aab808&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12aab808",
  null
  
)

export default component.exports